import React from "react"; 

export const MENSAGENS = {
    SEM_RESULTADOS_PARA_CONSULTA: "Sem resultados para a consulta.",
    RELACIONAMENTO_ALTERADO: "Relacionamento alterado com sucesso.",
};

export default MENSAGENS;